import apiClient from "../apiClient"
import { UserItem } from "./user"

// 获取当前用户信息
export const queryCurrentUser = async () => {
    return apiClient<UserItem>('/user/currentUser');
}